const resetOnboardingIntroChat = () => ({ type: 'onboardingResetIntroChat' });

export default resetOnboardingIntroChat;
